import { useEffect, useRef } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSearchParam } from "lib/@hooks/use-search-param"

export function OpenAmendFromUrl() {
    const [openAmend, setOpenAmend] = useSearchParam("openAmend", "")
    const { amendsContext } = useBoundContext()
    const handled = useRef("")

    useEffect(handleOpenAmend, [openAmend, amendsContext, setOpenAmend])

    return null

    function handleOpenAmend() {
        if (!openAmend || !amendsContext || handled.current === openAmend) return
        amendsContext.onOpenAmends(openAmend)
        setOpenAmend("")
        handled.current = openAmend

        scrollToAmend(openAmend)
    }
}

function scrollToAmend(amendsKey) {
    requestAnimationFrame(() => {
        const selectors = getScrollSelector(amendsKey)
        for (const selector of selectors) {
            const el = document.querySelector(selector)
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" })
                return
            }
        }
    })
}

function getScrollSelector(amendsKey) {
    switch (amendsKey) {
        case "leadingSummary":
            return ['[data-cy="leading-summary-amends"]', '[data-cy="leading-summary-amends-row"]']
        case "title":
            return ['[data-cy="schedule-title-amends"]', '[data-cy="schedule-title-amends-row"]']
        case "code":
            return ['[data-cy="schedule-code-amends"]', '[data-cy="schedule-code-amends-row"]']
        case "intro.content":
            return ['[data-cy="intro-content-amends"]', '[data-cy="intro-content-amends-row"]']
        case "intro.note":
            return ['[data-cy="intro-note-amends"]', '[data-cy="intro-note-amends-row"]']
        default:
            if (amendsKey?.startsWith("tasks.")) {
                return ['[data-cy="task-amends-editor"]']
            }
            return []
    }
}
